import { useRef } from "react";
import type { MouseEvent } from "react";

/**
 * Закрытие модалки по клику на затемнение — без ложных срабатываний.
 *
 * Простое onClick={onClose} на затемнении закрывает окно, когда человек выделяет
 * текст мышью: нажал внутри поля, довёл до начала строки и отпустил уже за краем
 * окна. Браузер шлёт click общему предку точек нажатия и отпускания — то есть
 * затемнению. Поэтому закрываем только если и mousedown, и click пришлись на
 * само затемнение (29.09.2026, «Фокусные» → «Текстовый отчёт»).
 *
 * Использование: <div className="bg" {...useBackdropClose(onClose)}>…</div>
 */
export function useBackdropClose(onClose: () => void) {
  const downOnBackdrop = useRef(false);
  return {
    onMouseDown: (e: MouseEvent) => {
      downOnBackdrop.current = e.target === e.currentTarget;
    },
    onClick: (e: MouseEvent) => {
      const ok = e.target === e.currentTarget && downOnBackdrop.current;
      downOnBackdrop.current = false;
      if (ok) onClose();
    },
  };
}
